import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

export const authGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authSrv = inject(AuthService);

  const currentAccessToken = authSrv.getAccessToken();
  const currentExp = authSrv.getAccessTokenExp();

  if (currentAccessToken) {
    const isExpired = Date.now() >= currentExp * 1000;

    if (isExpired) {
      console.log('Access Token Expired!');
      return router.navigate(['/auth/login']);
    }
    
    return true;
  }

  return router.navigate(['/auth/login']);
};
